import type { User } from '@datadog/browser-core';
import { datadogLogs } from '@datadog/browser-logs';

const urlMatchers = ['https://api.segment.io', 'https://cdn.segment.com'];

const ignoreMatchers = ['Font Awesome Kit: Error'];

const errorMatchers = [
  'Error sending segment performance metrics',
  'Failed to load Analytics.js',
  'Load failed',
  'HTTPError: 403', // error from cloudflare
];

function getServiceName() {
  return import.meta.env.VITE_APP_NAME + '-web';
}

let lastSpanId: unknown;
let lastTraceId: unknown;

export function init() {
  datadogLogs.init({
    clientToken: 'pubf1b3fd8bf6ce2148e6ce7eb8a7c80b3a',
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    version: import.meta.env.VITE_APP_RELEASE,
    env: import.meta.env.VITE_APP_TARGET,
    service: getServiceName(),
    forwardConsoleLogs: ['error'],
    beforeSend(log) {
      // inject trace into logs
      log.dd = { trace_id: lastTraceId, span_id: lastSpanId };

      for (const urlPart of urlMatchers) {
        if (log.http?.url.startsWith(urlPart)) {
          //skip logging this error
          return false;
        }
      }

      for (const ignoreMatcher of ignoreMatchers) {
        if (log.message.includes(ignoreMatcher)) {
          return false;
        }
      }

      //Transform all "Failed to fetch" errors to warnings
      if (log.http?.status_code === 0) {
        log.status = 'warn';
      }

      if (log.http?.status_code === 403) {
        log.status = 'warn';
      }

      for (const matchers of errorMatchers) {
        if (log.message.includes(matchers)) {
          log.status = 'warn';
        }
      }

      return true;
    },
  });
}

export function identifyUser(user: User) {
  datadogLogs.setUser(user);
}

export function getLogger() {
  return datadogLogs.logger;
}
